import React from "react";
import Logo from "./Logo";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";

export const Footer = ({ contact = {}, settings = {} }) => {
  return (
    <footer className="relative border-t border-gold/15 bg-onyx-900 pt-20 pb-10" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-6 md:grid-cols-4 md:px-10">
        <div className="md:col-span-2">
          <Logo size={120} withText />
          <p className="mt-6 max-w-md text-ivory/60 text-sm leading-relaxed">
            {settings.tagline || "Crafted in Mumbai. Premiered Worldwide."} We engineer cinema —
            from luxury vanity vans cruising Film City to the post houses of Andheri.
          </p>
          <a
            href={contact.instagram || "https://instagram.com/dhaddamotionpictures"}
            target="_blank"
            rel="noreferrer"
            className="mt-8 inline-flex items-center gap-3 text-gold hover:text-gold-bright transition-colors"
            data-testid="footer-instagram"
          >
            <Instagram size={18} />
            <span className="font-cinzel text-[11px] tracking-[0.3em] uppercase">
              {contact.instagram_handle || "@dhaddamotionpictures"}
            </span>
          </a>
        </div>

        <div>
          <h4 className="font-cinzel text-[11px] tracking-[0.3em] uppercase text-gold mb-5">
            Studio
          </h4>
          <div className="space-y-4 text-ivory/65 text-sm">
            <div className="flex items-start gap-3">
              <MapPin size={15} className="mt-0.5 text-gold/70 shrink-0" />
              <span data-testid="footer-address">{contact.address || "Goregaon Film City, Mumbai"}</span>
            </div>
            <div className="flex items-center gap-3">
              <Phone size={15} className="text-gold/70" />
              <a href={`tel:${contact.phone}`} className="hover:text-gold" data-testid="footer-phone">
                {contact.phone}
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Mail size={15} className="text-gold/70" />
              <a href={`mailto:${contact.email}`} className="hover:text-gold" data-testid="footer-email">
                {contact.email}
              </a>
            </div>
          </div>
        </div>

        <div>
          <h4 className="font-cinzel text-[11px] tracking-[0.3em] uppercase text-gold mb-5">
            Services
          </h4>
          <ul className="space-y-3 text-sm text-ivory/65">
            {["Vanity Vans", "Film Production", "Equipment Rental", "Location Scouting", "Crew & Casting", "Post-Production"].map(
              (s) => (
                <li key={s} className="hover:text-gold transition-colors cursor-default">
                  {s}
                </li>
              )
            )}
          </ul>
        </div>
      </div>

      <div className="gold-line mx-auto mt-16 max-w-[1400px]" />

      <div className="mx-auto mt-8 flex max-w-[1400px] flex-col gap-3 px-6 md:flex-row md:items-center md:justify-between md:px-10">
        <p className="text-xs text-ivory/40">
          © {new Date().getFullYear()} Dhadda Motion Pictures. All rights reserved.
        </p>
        <p className="font-cinzel text-[10px] tracking-[0.3em] uppercase text-gold/50">
          Mumbai • Film City • India
        </p>
      </div>
    </footer>
  );
};

export default Footer;
